import { createShallowStore, createStore } from '@frontend/store';

type InsuranceTabStore = {
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  currentFilterValue: string;
  setCurrentFilterValue: (value: string) => void;
  currentStatusSelection: string;
  setCurrentStatusSelection: (status: string) => void;
  insuranceStatusByPersonIdsMap?: Record<string, string>;
  setInsuranceStatusByPersonIdsMap: (map: Record<string, string>) => void;
  insuranceStatusCounts?: Record<string, number>;
  setInsuranceStatusCounts: (counts: Record<string, number>) => void;
  setRefetchInsuranceStatuses: (refetch: () => void) => void;
  refetchInsuranceStatuses?: () => void;
  shouldReportOpenInLargeModeSwitch: boolean;
  setShouldReportOpenInLargeModeSwitch: (value: boolean) => void;
};

const useInsuranceTabStore = createStore<InsuranceTabStore>(
  (set) => ({
    isLoading: false,
    shouldReportOpenInLargeModeSwitch: false, // Used only when switching to large mode on “View Report” click. Local state resets due to component remount, so this is stored in shared state to preserve the user action.
    currentFilterValue: '',
    insuranceStatusCounts: {},
    currentStatusSelection: '',
    insuranceStatusByPersonIdsMap: {},
    setIsPersonId: (personId: string) => set((state) => ({ ...state, personId })),
    setShouldReportOpenInLargeModeSwitch: (value) =>
      set((state) => ({ ...state, shouldReportOpenInLargeModeSwitch: value })),
    setCurrentFilterValue: (value) => set((state) => ({ ...state, currentFilterValue: value })),
    setCurrentStatusSelection: (status) => set((state) => ({ ...state, currentStatusSelection: status })),
    setInsuranceStatusByPersonIdsMap: (map) => set((state) => ({ ...state, insuranceStatusByPersonIdsMap: map })),
    setInsuranceStatusCounts: (counts) => set((state) => ({ ...state, insuranceStatusCounts: counts })),
    setIsLoading: (loading) => set((state) => ({ ...state, isLoading: loading })),
    setRefetchInsuranceStatuses: (refetch) => set((state) => ({ ...state, refetchInsuranceStatuses: refetch })),
  }),
  {
    name: 'insuranceTabStore',
  }
);

export const useInsuranceTabShallowStore = createShallowStore<InsuranceTabStore>(useInsuranceTabStore);
